var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLines = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 11,
    width: 71,
    fill: "#a1242d",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.6 1.4a1241.7 1241.7 0 0 1-60.9 1c-2-.2-7.3 1-8.8-1C4 .3 7.6.6 10.8.4 14.5.1 18.2 0 22 0c7.3 0 14.7.3 22.1.6l26.5.5v.2M62.6 9.5h-7.8c-1.3 0-2.6.2-3.9.4l-4 .4c-12.9.4-26 .9-39 .3-2.6-.1-5.2-.7-7.8-1L0 9.5v-.2C2.8 9 5.4 9 8 8.8c1.2 0 2.4-.2 3.7-.4 5.3-1 11-.3 16.4-.1 6.3.2 12.6.6 18.9.7h3.8c1.3-.2 2.7-.3 4-.2 2.6 0 5.2.4 7.8.5v.2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLines, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lines.507144a0.svg";
export { ForwardRef as ReactComponent };